import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import news from "../pdf/news.pdf";
import C_notice from "../pdf/C_notice.pdf";
import FacebookCard from "../Components/FacebookCard";

const InfoCards = () => {
  const marqueeRef = useRef(null);
  const marqueeRef2 = useRef(null);

  const handleMouseOver = () => {
    marqueeRef.current.stop();
  };
  const handleMouseOver2 = () => {
    marqueeRef2.current.stop();
  };

  const handleMouseOut = () => {
    marqueeRef.current.start();
  };
  const handleMouseOut2 = () => {
    marqueeRef2.current.start();
  };
  return (
    <div>
      <div className="row justify-content-center">
        <div className="col-md-3 col-sm-10 pt-md-3 pt-sm-5">
          <Card border="dark" className="h-100">
            <Card.Header
              className="text-center text-white fw-semibold fs-5"
              style={{ backgroundColor: "#25477c" }}
            >
              Notices
            </Card.Header>
            <Card.Body className="py-2">
              <Card.Text className="text-dark">
                <marquee
                  ref={marqueeRef}
                  width="100%"
                  direction="up"
                  scrollamount="3"
                  height="250px"
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                >
                  <a
                    href="https://vcourts.gov.in/virtualcourt/"
                    target="_blank"
                    className="text-decoration-none"
                  >
                    <h6>Pay Your Traffic Challan</h6>
                    <br />
                  </a>
                  <hr />
                  <a
                    href={news}
                    target="_blank"
                    className="text-decoration-none  "
                  >
                    {" "}
                    <h6>News</h6>
                    <br />
                  </a>
                  <hr className="w-100" />
                  <a
                    href={C_notice}
                    target="_blank"
                    className="text-decoration-none"
                  >
                    <h6>Court Notice</h6>
                    <br />
                  </a>
                  <hr />
                  <a
                    href="https://dehradun.dcourts.gov.in/holiday-list/"
                    target="_blank"
                    className="text-decoration-none"
                  >
                    <h6>Holiday List</h6>
                    <br />
                  </a>
                </marquee>
              </Card.Text>
            </Card.Body>
            <Card.Footer className="text-center">
              <Button href="/Notices" style={{ backgroundColor: "#25477c" }}>
                View All
              </Button>
              <small className="text-muted"></small>
            </Card.Footer>
          </Card>
        </div>
        <div className="col-md-3 col-sm-10 pt-md-3 pt-sm-4">
          <Card border="dark" className="h-100">
            <Card.Header
              className="text-center text-white fw-semibold fs-5"
              style={{ backgroundColor: "#25477c" }}
            >
              Facebook
            </Card.Header>
            <Card.Body className="pb-2 pt-2">
              <FacebookCard />
            </Card.Body>
            {/* <Card.Footer className="text-center">
              <Button style={{ backgroundColor: "#25477c" }}>View All</Button>
              <small className="text-muted"></small>
            </Card.Footer> */}
          </Card>
        </div>

        <div className="col-md-3 col-sm-10 pt-md-3 pt-sm-4">
          <Card border="dark" className="h-100">
            <Card.Header
              className="text-center text-white fw-semibold fs-5"
              style={{ backgroundColor: "#25477c" }}
            >
              Activities
            </Card.Header>
            <Card.Body className="py-2">
              <Card.Text>
                <marquee
                  ref={marqueeRef2}
                  width="100%"
                  direction="up"
                  scrollamount="4"
                  height="250px"
                  onMouseOver={handleMouseOver2}
                  onMouseOut={handleMouseOut2}
                >
                  <a
                    href="/Activities"
                    target="_blank"
                    className="text-decoration-none"
                  >
                    <h6>Ambedkar jayanti 2024</h6>
                    <br />
                  </a>
                  <hr />
                  <a
                    href="/Activities"
                    target="_blank"
                    className="text-decoration-none"
                  >
                    {" "}
                    <h6>Womens Day March 2024</h6>
                    <br />
                  </a>
                  <hr className="w-100" />
                  <a
                    href="/Activities"
                    target="_blank"
                    className="text-decoration-none"
                  >
                    <h6>General Meeting 2024</h6>
                    <br />
                  </a>
                </marquee>
              </Card.Text>
            </Card.Body>
            <Card.Footer className="text-center">
              <Button href="/Activities" style={{ backgroundColor: "#25477c" }}>
                View All
              </Button>
              <small className="text-muted"></small>
            </Card.Footer>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default InfoCards;
